import { MyPlaylistsTabs } from '../features/myPlaylists';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyPlaylists = () => {
  return /*#__PURE__*/_jsx(MyPlaylistsTabs, {});
};
export default MyPlaylists;